import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useTranslation } from 'react-i18next';

import { handleErrorInsideQuery } from '@shared/helpers';
import { IDataResponseError } from '@shared/model/types/dataResponse.inteface';
import { sendPollResult } from '@widgets/UserPoll/api/sendPollResult';

export const useSendPollResult = () => {
    const { t } = useTranslation();
    return useMutation({
        mutationKey: ['send-poll-result'],
        mutationFn: sendPollResult,
        onError: (error: AxiosError<IDataResponseError>) => {
            handleErrorInsideQuery(error, t('button.got_it.text'));
        },
    });
};
